import * as R from 'remeda';
import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { SavedView } from '@rossum/api-client/savedViews';
import { api } from '../../../lib/apiClient';
import { CodecFieldTypes } from '../../mql/constants';
import { decodeMqlQuery } from '../../mql/decodeMqlQuery';
import { detailsDecoder } from '../../mql/detailsCodec';
import { ParsedSavedView, parseIncomingViewQuery } from '../core';

export const GET_SAVED_VIEWS_QUERY = 'get-saved-views';

type UseGetSavedViewsProps = {
  codecFieldTypes: CodecFieldTypes;
  queueId: number;
};

const resolveSavedViewsResponse = ({
  data,
  codecFieldTypes,
}: {
  data: SavedView[];
  codecFieldTypes: CodecFieldTypes;
}): ParsedSavedView[] =>
  R.pipe(
    data,
    R.map(view => ({
      ...view,
      query: parseIncomingViewQuery(view.query, { id: view.id }),
    })),
    R.flatMap(view =>
      view.query
        ? [
            {
              ...view,
              parsedQuery: decodeMqlQuery(view.query, {
                codecFieldTypes,
                columnDecoders: { details: detailsDecoder },
              }),
            },
          ]
        : []
    )
  );

export const useGetSavedViews = ({
  codecFieldTypes,
  queueId,
}: UseGetSavedViewsProps) => {
  return useQuery({
    queryKey: [GET_SAVED_VIEWS_QUERY, queueId] as const,
    queryFn: () =>
      api.unpaginatedRequest(endpoints.savedViews.list)({ queueId }),
    select: data => resolveSavedViewsResponse({ data, codecFieldTypes }),
  });
};
